<template>
  <div
    class="d-none d-md-flex w-100 subheader"
    style="
      background-color: #ededed;
      min-height: 90px;
      box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.15);
    "
  >
    <div class="container-fluid position-relative">
      <div class="row align-items-center my-links">
        <div>
          <router-link
            :class="{ 'link-active': !my && !favourites }"
            to="/panel/diagrams"
            @click.native="clearFiltering"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 32 32"
            >
              <path
                d="M8 4v4H4V4zm2-2H2v8h8zm8 2v4h-4V4zm2-2h-8v8h8zm8 2v4h-4V4zm2-2h-8v8h8zM8 14v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zM8 24v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8z"
                fill="currentColor"
              ></path>
            </svg>
            Slides library
          </router-link>
          <a
            href="#"
            :class="{ 'link-active': my }"
            @click.prevent="loadMySlides"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 32 32"
            >
              <path
                d="M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z"
                fill="currentColor"
              ></path>
              <path
                d="M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z"
                fill="currentColor"
              ></path>
            </svg>
            My slides
          </a>
          <a
            href="#"
            :class="{ 'link-active': favourites }"
            @click.prevent="loadFavourites"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 32 32"
            >
              <path
                d="M22.45 6a5.47 5.47 0 0 1 3.91 1.64a5.7 5.7 0 0 1 0 8L16 26.13L5.64 15.64a5.7 5.7 0 0 1 0-8a5.48 5.48 0 0 1 7.82 0l2.54 2.6l2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0a7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z"
                fill="currentColor"
              ></path>
            </svg>
            My wishlist
          </a>
        </div>
        <div>
          <Search />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from 'components/Panel/Search.vue'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Navigation',
  computed: {
    ...mapState('filtering', ['my', 'favourites'])
  },
  methods: {
    ...mapMutations('filtering', ['clearFiltering']),
    loadFavourites () {
      this.clearFiltering()
      this.$store.commit('filtering/toggleFavourites')
    },
    loadMySlides () {
      this.clearFiltering()
      this.$store.commit('filtering/toggleMy')
    }
  },
  components: {
    Search
  }
}
</script>

<style lang="scss">
.subheader {
  align-items: center;
  padding: 12px 0;
}
.my-links {
  & > div {
    flex: 1 1 auto;
    width: auto;
  }
  a {
    font-size: 20px;
    line-height: 27px;
    margin-right: 16px;
    color: var(--c-grey);
  }
  .link-active {
    color: #ffaa00;
  }
  svg {
    width: 30px;
    height: 30px;
  }
  & > .col {
    padding: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 940px) {
    & > div {
      width: 100%;
      align-items: center;
      display: flex;
      justify-content: center;
      flex: 1 1 auto;
      .search {
        width: 100%;
        .row {
          justify-content: center !important;
        }
      }
      & + div {
        padding-top: 20px;
      }
    }
  }
  @media screen and (min-width: 980px) and (max-width: 1220px) {
    a {
      font-size: 18px;
      line-height: 24px;
      svg {
        width: 26px;
        height: 26px;
      }
    }
  }
  @media screen and (max-width: 980px) {
    a {
      font-size: 16px;
      line-height: 24px;
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
